import { render } from "./AwardExchange.vue?vue&type=template&id=7ec356a3&scoped=true&ts=true"
import script from "./AwardExchange.vue?vue&type=script&lang=ts"
export * from "./AwardExchange.vue?vue&type=script&lang=ts"

import "./AwardExchange.vue?vue&type=style&index=0&id=7ec356a3&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec356a3"]])

export default __exports__